import { type ModalArgs } from '#app/components/Modals/V2/GlobalModalSystem/types.js';
import { useModal } from '#app/components/Modals/V2/GlobalModalSystem/useModal.js';

export const useMessageSentModal = ({
  onClose,
}: ModalArgs<'MessageSentModal'>) => {
  const { isModalOpen, openModal: openMessageSentModal } = useModal({
    identifier: 'MessageSentModal',
    modalProps: {
      onClose,
    },
  });

  return { isModalOpen, openMessageSentModal };
};
